import { Component, input, output } from '@angular/core';
import { FilterHeaderComponent } from '@vectronic/ui';

@Component({
  selector: 'table-datatable-filter-boolean',
  templateUrl: './datatable-filter-boolean.component.html',
  imports: [FilterHeaderComponent],
})
export class DatatableFilterBooleanComponent {
  title = input.required<string>();
  value = input<boolean | undefined>();

  valueChange = output<boolean | undefined>();

  onToggle() {
    const newValue = this.value() === true ? undefined : true;
    this.valueChange.emit(newValue);
  }
}
